
<template>
  <div class="left" v-bind="$attrs" @click="$emit('click')"/>
</template>

<script>
export default {
  name: 'Left',
}
</script>

<style lang="scss" scoped>
.left {
  position: absolute;
  top: 0;
  left: 0;
  width: 0.46rem;
  height: 1.04rem;
  z-index: 100;
  background-image: url(../assets/img/icon/left.png);
  background-size: 100% 100%;
  cursor: pointer;
  transition: all 0.3s ease-out;
  &:hover {
    transform: scale(1.2) translateX(-0.08rem);
  }
}
</style>
